import Swiper from "swiper";
import { Pagination } from 'swiper/modules';
import 'swiper/css'
import "swiper/swiper-bundle.css";

export default class SuccessStoriesFullSwiper {
    constructor() {
        const wrapper = document.querySelectorAll('.success-stories-full-swiper__widget-wrapper');

        if (!wrapper.length) {
            return;
        }
        
        wrapper.forEach((wrap) => {
            const storySwiper = new Swiper('.success-stories__swiper', {
                slidesPerView: 1,
                spaceBetween: 30,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                modules: [ Pagination ],
            })
        });
    }
}